import styled from "styled-components";

export default styled.h6`
  padding: 0;
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 1;
  color: #ffffff;
`;
